import { faWarning } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { BodyL, HeadlineS } from 'atoms/typography';

const Root = styled.div`
  padding: var(--unit) var(--double-unit);
  width: 100%;
  background: linear-gradient(
      0deg,
      rgba(var(--c-rgb-yellow-300), 0.16),
      rgba(var(--c-rgb-yellow-300), 0.16)
    ),
    var(--c-black);
  border: 1px solid var(--c-yellow-600);
  border-radius: var(--unit);
`;

type Props = {
  title: string;
  message: string;
};
export const Alert = ({ title, message }: Props) => {
  return (
    <Root>
      <HeadlineS>
        <FontAwesomeIcon icon={faWarning} color="var(--c-yellow-600)" /> {title}
      </HeadlineS>
      <BodyL>{message}</BodyL>
    </Root>
  );
};
